import React, { Component } from 'react';
import * as Yup from 'yup';
import { Form, Formik, Field, ErrorMessage } from 'formik';
import PropTypes from 'prop-types';
import {
  participantAge,
  participantLocation,
  participantOccupation
} from '../data/participantDetails';

const Schema = Yup.object().shape( {
  participantage: Yup.string(),
  participantoccupation: Yup.string(),
  participantlocation: Yup.string(),
} );

class CollectionFilter extends Component {

  submitHandler = ( values ) => {
    this.props.submitHandler(values);
  };

  render() {
    return (
      <Formik
        initialValues={{
          participantage: 'all',
          participantoccupation: 'all',
          participantlocation: 'all',
        }}
        validationSchema={Schema}
        onSubmit={( values, { setSubmitting } ) => {
          this.submitHandler( values );
          setSubmitting( false );
        }}>
        {({ values, handleChange, submitForm }) => (
          <Form>
            <h3 className="regular">These avatars were <strong className="highlight-yellow">created by people who are</strong>: </h3>
            <p className="input-holder">
              <label>Aged</label>
              <Field as="select" name="participantage"
                value={values.participantage}
                onChange={(e) => {
                  handleChange(e);
                  submitForm();
                }}>
                <option value="all">all ages</option>
                {participantAge.map(ageRange => <option key={ageRange.value} value={ageRange.value}>{ageRange.text}</option>)}
              </Field>
              <ErrorMessage name="participantage" component="div"/>
            </p>

            <p className="input-holder">
              <label>Working in</label>
              <Field as="select" name="participantoccupation"
                value={values.participantoccupation}
                onChange={(e) => {
                  handleChange(e);
                  submitForm();
                }}>
                <option value="all">all occupations</option>
                {participantOccupation.map(occupation => <option key={occupation.value} value={occupation.value}>{occupation.text}</option>)}
              </Field>
              <ErrorMessage name="participantoccupation" component="div"/>
            </p>

            <p className="input-holder">
              <label>From</label>
              <Field as="select" name="participantlocation"
                value={values.participantlocation}
                onChange={(e) => {
                  handleChange(e);
                  submitForm();
                }}>
                <option value="all">all countries</option>
                {participantLocation.map(location => <option key={location.value} value={location.value}>{location.text}</option>)}
              </Field>
              <ErrorMessage name="participantlocation" component="div"/>
            </p>

          </Form>
        )}
      </Formik>
    )
  }

}

CollectionFilter.propTypes = {
  submitHandler: PropTypes.func
};

export default CollectionFilter;
